import React, { useEffect, useRef, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const submittedRef = useRef(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Pago completado.");
          break;
        case "processing":
          setMessage("Tu pago se está procesando. Recibirás un email cuando se confirme.");
          break;
        case "requires_payment_method":
          setMessage("El pago no se completó. Revisa tus datos e inténtalo de nuevo.");
          break;
        case "requires_action":
          setMessage("Tu banco requiere autenticación adicional. Sigue las instrucciones para completar el pago.");
          break;
        default:
          setMessage("Ha ocurrido un error inesperado procesando el pago.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    // F2: bloqueo inmediato contra doble-submit
    if (submittedRef.current) return;
    submittedRef.current = true;
    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
    });

    // F1: error puede ser undefined en el happy path (redirect ya ocurrió)
    if (error?.type === "card_error" || error?.type === "validation_error") {
      setMessage(error.message);
    } else if (error) {
      setMessage("Ha ocurrido un error procesando el pago. Verifica tus datos e intenta de nuevo.");
    }

    setIsLoading(false);
    submittedRef.current = false;
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <button type="submit" disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}